const APP_POPOUT_SIZE = { width: 360, height: 680 };
const APP_DEVICE_TYPE = {
  mobile: 'mobile',
  desktop: 'desktop'
};
const APP_CAPABILITIES = [
  //APIs
  'getMeetingContext',
  'getUserContext',
  'getMeetingJoinUrl',
  'getMeetingUUID',
  'openUrl',
  'makePhoneCall',
  'onRunningContextChange'
  //'getMeetingParticipants',
  //'onParticipantChange'
];

const DIRECTORY_APP_CAPABILITIES = ['openUrl', 'onRunningContextChange'];

const APP_RUNNING_CONTEXT_IN_MEETING = 'inMeeting';

const MAKEPHONECALL_SUCCESS = 'Success';
const MAKEPHONECALL_FAILURE = 'Failure';

export { APP_POPOUT_SIZE, APP_CAPABILITIES, APP_DEVICE_TYPE, DIRECTORY_APP_CAPABILITIES, APP_RUNNING_CONTEXT_IN_MEETING, MAKEPHONECALL_SUCCESS, MAKEPHONECALL_FAILURE };
